import { createSlice } from "@reduxjs/toolkit";
import type { Key } from "react";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { NoteManagerTableState } from "./types";
import type { SortConfig } from "@/shared/Components";
import type { FilterValue } from "antd/es/table/interface";

const initialState: NoteManagerTableState = {
  sorter: {
    fieldName: ["noteDate"],
    order: "ascend",
  },
  selectedIds: [],
  deleteModalIsOpen: false,
};

export const notesManagerTableSlice = createSlice({
  name: "notesManagerTable",
  initialState,
  reducers: {
    setSorter: (state, action: PayloadAction<SortConfig>) => {
      state.sorter = action.payload;
    },
    setFilter: (state, action: PayloadAction<Record<string, FilterValue>>) => {
      state.filters = action.payload;
    },
    setSelectedRowKeys: (state, action: PayloadAction<Key[]>) => {
      state.selectedIds = action.payload;
    },
    openDeleteModal: (state) => {
      state.deleteModalIsOpen = true;
    },
    closeDeleteModal: (state) => {
      state.deleteModalIsOpen = false;
    },
    resetState: (state) => {
      Object.assign(state, initialState);
    },
  },
  selectors: {
    selectSelectedTableIds: (state) => state.selectedIds,
    selectDeleteModalIsOpen: (state) => state.deleteModalIsOpen,
  },
});

export const { actions: notesTableSliceActions, selectors: notesTableSliceSelectors } =
  notesManagerTableSlice;
